export default __webpack_public_path__ + "static/media/image_upload_icon.dccf91f0.png";